export const SIGNS = {
    "ar": "aries",
    "ta": "taurus",
    "ge": "gemini",
    "cn": "cancer",
    "le": "leo",
    "vi": "virgo",
    "li": "libra",
    "sc": "scorpio",
    "sa": "sagittarius",
    "cp": "capricorn",
    "aq": "aquarius",
    "pi": "pisces"
};